import { render, staticRenderFns } from "./legal-documents.vue?vue&type=template&id=22580536&lang=pug"
import script from "./legal-documents.vue?vue&type=script&lang=js"
export * from "./legal-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports